export default __webpack_public_path__ + "static/media/pax.aec3f74a.svg";